import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "flex h-full w-full min-w-0 flex-col gap-5 overflow-y-auto overflow-x-hidden p-4 pt-20 xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-col gap-2" };
const _hoisted_3 = { class: "text-2xl font-bold tracking-tight text-eblack-900" };
const _hoisted_4 = { class: "text-sm text-eblack-500" };
const _hoisted_5 = { class: "flex flex-col gap-3.5" };
const _hoisted_6 = { class: "relative w-full md:max-w-md" };
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = {
    key: 0,
    class: "flex flex-wrap items-center gap-3"
};
const _hoisted_9 = { class: "flex flex-wrap gap-2" };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "ml-auto whitespace-nowrap text-sm text-eblack-500" };
const _hoisted_12 = {
    key: 0,
    class: "rounded-xl border border-red-200 bg-red-50 p-8 text-center text-sm text-red-700"
};
const _hoisted_13 = {
    key: 1,
    class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-8"
};
const _hoisted_14 = {
    key: 2,
    class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-8"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "flex items-start gap-3" };
const _hoisted_17 = { class: "flex h-[52px] w-[52px] flex-shrink-0 items-center justify-center rounded-full border border-ewhite-200 bg-eblack-50 text-base font-bold text-eblack-700" };
const _hoisted_18 = { class: "min-w-0 flex-1" };
const _hoisted_19 = { class: "line-clamp-2 text-base font-semibold leading-tight tracking-tight text-eblack-900" };
const _hoisted_20 = { class: "mt-0.5 truncate text-[13px] font-medium text-eblack-500" };
const _hoisted_21 = { class: "flex-shrink-0 rounded-full bg-egreen-100 px-2.5 py-1 text-[11px] font-semibold text-egreen-700" };
const _hoisted_22 = { class: "line-clamp-2 text-sm leading-relaxed text-eblack-600" };
const _hoisted_23 = {
    key: 0,
    class: "flex flex-wrap gap-1.5"
};
const _hoisted_24 = { class: "flex flex-col gap-2" };
const _hoisted_25 = { class: "text-[11px] font-bold uppercase tracking-wide text-eblack-400" };
const _hoisted_26 = { class: "flex flex-col gap-1.5" };
const _hoisted_27 = { class: "min-w-0 flex-1 truncate text-[13px] font-medium text-eblack-700" };
const _hoisted_28 = {
    key: 0,
    class: "flex-shrink-0 text-xs text-eblack-400"
};
const _hoisted_29 = {
    key: 0,
    class: "text-xs font-semibold text-eblack-900"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
    key: 3,
    class: "flex flex-col items-center justify-center rounded-2xl border border-ewhite-200 bg-ewhite-50 px-8 py-16 text-center"
};
const _hoisted_32 = { class: "flex h-[72px] w-[72px] items-center justify-center rounded-full bg-ewhite-100" };
const _hoisted_33 = { class: "mt-4 text-lg font-semibold text-eblack-900" };
const _hoisted_34 = { class: "mt-2 max-w-sm text-sm leading-relaxed text-eblack-500" };
import { i18n } from "@/i18n";
import { computed, onMounted, ref } from "vue";
import { IconSearch, IconUsers } from "@tabler/icons-vue";
import { useToast } from "vue-toastification";
import providerCatalogRequests from "@/services/admin/provider-catalog-service";
import { getCountryName } from "@/utils/country-name";
import { useOverlay } from "@/services/overlay-service";
import { createModalConfig } from "@/utils/overlay-utils";
import ProviderCatalogCardSkeleton from "./components/ProviderCatalogCardSkeleton.vue";
import ProviderCatalogDetailModal from "./components/ProviderCatalogDetailModal.vue";
const VISIBLE_SERVICES = 3;
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProviderCatalogIndex',
    setup(__props) {
        const toast = useToast();
        const overlayService = useOverlay();
        const providers = ref([]);
        const isInitialLoading = ref(true);
        const error = ref(false);
        const search = ref("");
        const activeCategory = ref(null);
        const availableCategories = computed(() => {
            const names = providers.value.flatMap((provider) => provider.categories);
            return [...new Set(names.filter(Boolean))].sort((a, b) => a.localeCompare(b));
        });
        const filteredProviders = computed(() => {
            const value = search.value.trim().toLowerCase();
            return providers.value.filter((provider) => {
                if (activeCategory.value && !provider.categories.includes(activeCategory.value)) {
                    return false;
                }
                if (!value)
                    return true;
                return [
                    provider.name,
                    provider.description,
                    provider.country_name,
                    provider.location_one,
                    provider.location_two,
                    ...provider.categories,
                    ...provider.services.map((service) => service.name),
                ]
                    .filter(Boolean)
                    .some((item) => String(item).toLowerCase().includes(value));
            });
        });
        const hasActiveFilters = computed(() => Boolean(search.value.trim()) || activeCategory.value !== null);
        function selectCategory(category) {
            activeCategory.value = category;
        }
        function clearFilters() {
            search.value = "";
            activeCategory.value = null;
        }
        function initials(name) {
            return name
                .split(/\s+/)
                .filter(Boolean)
                .slice(0, 2)
                .map((word) => word[0]?.toUpperCase() ?? "")
                .join("");
        }
        function locationLabel(provider) {
            const country = provider.country_name || getCountryName(provider.country);
            return [country, provider.location_one, provider.location_two, provider.location_three]
                .filter(Boolean)
                .join(", ");
        }
        function visibleServices(provider) {
            return provider.services.slice(0, VISIBLE_SERVICES);
        }
        function extraServiceCount(provider) {
            return Math.max(0, provider.service_count - visibleServices(provider).length);
        }
        function openProviderDetail(provider) {
            overlayService.open(createModalConfig({
                component: ProviderCatalogDetailModal,
                size: "lg",
                props: { provider },
            }));
        }
        async function loadProviders() {
            error.value = false;
            try {
                const response = await providerCatalogRequests.getAll();
                providers.value = response.data ?? [];
            }
            catch {
                error.value = true;
                toast.error(i18n.global.t("provider.auto.no_se_pudieron_cargar_los_proveedores"));
            }
            finally {
                isInitialLoading.value = false;
            }
        }
        onMounted(loadProviders);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("provider.auto.proveedores")), 1),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("provider.auto.directorio_informativo_de_proveedores_disponible")), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(IconSearch), { class: "absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-eblack-400" }),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                            type: "text",
                            class: "h-12 w-full rounded-xl border border-ewhite-300 bg-white px-4 pl-10 text-sm text-eblack-900 placeholder:text-eblack-400 focus:border-eblack-400 focus:ring-0",
                            placeholder: _ctx.$t('provider.auto.buscar_proveedores')
                        }, null, 8, _hoisted_7), [
                            [_vModelText, search.value]
                        ])
                    ]),
                    (isInitialLoading.value || providers.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["rounded-full border px-4 py-1.5 text-[13px] font-semibold transition",
                                        activeCategory.value === null
                                            ? 'border-eblack-900 bg-white text-eblack-900 shadow-[inset_0_0_0_1px_#333333]'
                                            : 'border-ewhite-300 bg-white text-eblack-700 hover:border-eblack-300'
                                    ]),
                                    onClick: _cache[1] || (_cache[1] = ($event) => (selectCategory(null)))
                                }, _toDisplayString(_ctx.$t("provider.auto.todos")), 3),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableCategories.value, (category) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                        key: category,
                                        type: "button",
                                        class: _normalizeClass(["rounded-full border px-4 py-1.5 text-[13px] font-semibold transition",
                                            activeCategory.value === category
                                                ? 'border-eblack-900 bg-white text-eblack-900 shadow-[inset_0_0_0_1px_#333333]'
                                                : 'border-ewhite-300 bg-white text-eblack-700 hover:border-eblack-300'
                                        ]),
                                        onClick: ($event) => (selectCategory(category))
                                    }, _toDisplayString(category), 11, _hoisted_10));
                                }), 128))
                            ]),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("provider.auto.n_proveedores", { count: filteredProviders.value.length })), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (error.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t("provider.auto.no_se_pudieron_cargar_los_proveedores")), 1))
                    : (isInitialLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                                return _createVNode(ProviderCatalogCardSkeleton, { key: n });
                            }), 64))
                        ]))
                        : (filteredProviders.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProviders.value, (provider) => {
                                    return (_openBlock(), _createElementBlock("article", {
                                        key: provider.id,
                                        class: "group flex cursor-pointer flex-col gap-3.5 rounded-2xl border border-ewhite-200 bg-white p-5 shadow-[0_1px_2px_rgba(0,0,0,0.03)] transition hover:border-ewhite-300 hover:shadow-[0_4px_16px_rgba(0,0,0,0.06)]",
                                        onClick: ($event) => (openProviderDetail(provider))
                                    }, [
                                        _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("div", _hoisted_17, _toDisplayString(initials(provider.name)), 1),
                                            _createElementVNode("div", _hoisted_18, [
                                                _createElementVNode("h2", _hoisted_19, _toDisplayString(provider.name), 1),
                                                _createElementVNode("p", _hoisted_20, _toDisplayString(locationLabel(provider) || _ctx.$t("provider.auto.ubicacion_no_especificada")), 1)
                                            ]),
                                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("provider.auto.activo")), 1)
                                        ]),
                                        _createElementVNode("p", _hoisted_22, _toDisplayString(provider.description || _ctx.$t("provider.auto.sin_descripcion_disponible")), 1),
                                        (provider.categories.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provider.categories, (category) => {
                                                    return (_openBlock(), _createElementBlock("span", {
                                                        key: category,
                                                        class: "rounded-full bg-ewhite-100 px-2.5 py-1 text-xs font-medium text-eblack-600"
                                                    }, _toDisplayString(category), 1));
                                                }), 128))
                                            ]))
                                            : _createCommentVNode("", true),
                                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h-px bg-ewhite-200" }, null, -1)),
                                        _createElementVNode("div", _hoisted_24, [
                                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("provider.auto.n_servicios", { count: provider.service_count })), 1),
                                            _createElementVNode("div", _hoisted_26, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleServices(provider), (service) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: service.id,
                                                        class: "flex items-baseline justify-between gap-3"
                                                    }, [
                                                        _createElementVNode("span", _hoisted_27, _toDisplayString(service.name), 1),
                                                        (service.category_name)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(service.category_name), 1))
                                                            : _createCommentVNode("", true)
                                                    ]));
                                                }), 128)),
                                                (extraServiceCount(provider) > 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t("provider.auto.mas_servicios", { count: extraServiceCount(provider) })), 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "mt-1 self-start text-sm font-semibold text-eblack-900 underline underline-offset-2 hover:text-eblack-950",
                                            onClick: _withModifiers(($event) => (openProviderDetail(provider)), ["stop"])
                                        }, _toDisplayString(_ctx.$t("provider.auto.ver_detalles")), 9, _hoisted_30)
                                    ], 8, _hoisted_15));
                                }), 128))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_unref(IconUsers), { class: "h-8 w-8 text-eblack-300" })
                                ]),
                                _createElementVNode("h2", _hoisted_33, _toDisplayString(_ctx.$t("provider.auto.no_encontramos_proveedores")), 1),
                                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("provider.auto.sin_resultados_ayuda")), 1),
                                (hasActiveFilters.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "mt-6 rounded-lg border border-ewhite-300 px-4 py-2 text-sm font-semibold text-eblack-900 transition hover:bg-ewhite-100",
                                        onClick: clearFilters
                                    }, _toDisplayString(_ctx.$t("provider.auto.limpiar_filtros")), 1))
                                    : _createCommentVNode("", true)
                            ]))
            ]));
        };
    }
});
